import {request} from "@/util/request";

export function GetPurchaseList(params) {
    return request({
        url: '/Purchase.asmx/GetPurchaseList',
        method: 'GET',
        params
    })
}

export function GetPurchaseInfo(params) {
    return request({
        url: '/Purchase.asmx/GetPurchaseInfo',
        method: 'GET',
        params
    })
}


export function PurchaseSpTy(params) {
    return request({
        url: '/Purchase.asmx/PurchaseSpTy',
        method: 'GET',
        params
    })
}

export function PurchaseSpBty(params) {
    return request({
        url: '/Purchase.asmx/PurchaseSpBty',
        method: 'GET',
        params
    })
}


